<gp-letters-filters
  [statusId]="GpAddressStatus.unresponsive"
  [verified]="GpAddressVerifiedStatus.notVerified"
  (filterChanged)="onFilterChanged($event)"
></gp-letters-filters>
<div>
  @if (dataSource.data.length) {
    <ng-container *ngTemplateOutlet="paginatorComponent"></ng-container>
  }
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 table table-striped">
    <ng-container matColumnDef="visit_id">
      <th mat-header-cell *matHeaderCellDef class="th">Visit ID</th>
      <div class="td" mat-cell *matCellDef="let element">{{ element.visit_id }}</div>
      <div class="td" mat-cell *matCellDef="let element">{{ element.visit_id }}</div>
    </ng-container>
    <ng-container matColumnDef="service">
      <th mat-header-cell *matHeaderCellDef class="th">Service</th>
      <div class="td" mat-cell *matCellDef="let element">{{ element.service }}</div>
    </ng-container>
    <ng-container matColumnDef="medications">
      <th mat-header-cell *matHeaderCellDef class="th">Medication</th>
      <div class="td" mat-cell *matCellDef="let element">{{ element.medications.join(', ') }}</div>
    </ng-container>
    <ng-container matColumnDef="surgery_name">
      <th mat-header-cell *matHeaderCellDef class="th">GP Name</th>
      <div class="td" mat-cell *matCellDef="let element">
        @if (!element.editMode) {
          {{ element.surgery_name }}
        } @else {
          <input [(ngModel)]="element.clone.surgery_name" placeholder="Gp Name" />
        }
      </div>
    </ng-container>
    <ng-container matColumnDef="line_1">
      <th mat-header-cell *matHeaderCellDef class="th">Line 1</th>
      <div class="td" mat-cell *matCellDef="let element">
        @if (!element.editMode) {
          {{ element.line_1 }}
        } @else {
          <input [(ngModel)]="element.clone.line_1" placeholder="Line 1" />
        }
      </div>
    </ng-container>
    <ng-container matColumnDef="line_2">
      <th mat-header-cell *matHeaderCellDef class="th">Line 2</th>
      <div class="td" mat-cell *matCellDef="let element">
        @if (!element.editMode) {
          {{ element.line_2 }}
        } @else {
          <input [(ngModel)]="element.clone.line_2" placeholder="line2" />
        }
      </div>
    </ng-container>
    <ng-container matColumnDef="line_3">
      <th mat-header-cell *matHeaderCellDef class="th">Line 3</th>
      <div class="td" mat-cell *matCellDef="let element">
        @if (!element.editMode) {
          {{ element.line_3 }}
        } @else {
          <input [(ngModel)]="element.clone.line_3" placeholder="line3" />
        }
      </div>
    </ng-container>
    <ng-container matColumnDef="town">
      <th mat-header-cell *matHeaderCellDef class="th">City</th>
      <div class="td" mat-cell *matCellDef="let element">
        @if (!element.editMode) {
          {{ element.town }}
        } @else {
          <input [(ngModel)]="element.clone.town" placeholder="City" />
        }
      </div>
    </ng-container>
    <ng-container matColumnDef="postcode">
      <th mat-header-cell *matHeaderCellDef class="th">Postcode</th>
      <div class="td" mat-cell *matCellDef="let element">
        @if (!element.editMode) {
          {{ element.postcode }}
        } @else {
          <input [(ngModel)]="element.clone.postcode" placeholder="postcode" />
        }
      </div>
    </ng-container>
    <ng-container matColumnDef="created">
      <th mat-header-cell *matHeaderCellDef class="th">Created</th>
      <div class="td" mat-cell *matCellDef="let element">{{ element.created | timeAgo }}</div>
    </ng-container>
    <ng-container matColumnDef="noOfContacts">
      <th mat-header-cell *matHeaderCellDef class="th">No. of Contacts</th>
      <div class="td" mat-cell *matCellDef="let element">{{ element.noOfContacts }}</div>
    </ng-container>
    <ng-container matColumnDef="lastContacted">
      <th mat-header-cell *matHeaderCellDef class="th">Last contacted</th>
      <div class="td" mat-cell *matCellDef="let element">
        {{ element.lastContacted ? (element.lastContacted | timeAgo) : '-' }}
      </div>
    </ng-container>
    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef class="th"></th>
      <div class="td" mat-cell *matCellDef="let element">
        @if (!element.editMode) {
          <button (click)="element.editMode = true" class="table-btn">Edit</button>
        } @else {
          <button (click)="saveChanges(element)" class="table-btn">Save</button>
          <button (click)="cancelEditMode(element)" class="table-btn">Cancel</button>
        }
      </div>
    </ng-container>
    <ng-container matColumnDef="follow up">
      <th mat-header-cell *matHeaderCellDef class="th"></th>
      <div class="td" mat-cell *matCellDef="let element">
        <followup-button [address]="element"></followup-button>
      </div>
    </ng-container>
    <ng-container matColumnDef="verify">
      <th mat-header-cell *matHeaderCellDef class="th"></th>
      <div class="td" mat-cell *matCellDef="let element">
        <status-update-button
          [address]="element"
          [label]="'Verify'"
          [toggledLabel]="'Deny'"
          [toggleStatus]="GpAddressStatus.verified"
          [defaultStatus]="GpAddressStatus.unresponsive"
        ></status-update-button>
      </div>
    </ng-container>

    <tr class="tr" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr class="tr" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        <div class="no-items-container"><span>No data avaliable</span></div>
      </td>
    </tr>
  </table>

  @if (dataSource.data.length > 5) {
    <ng-container *ngTemplateOutlet="paginatorComponent"></ng-container>
  }
</div>

<ng-template #paginatorComponent>
  <mat-paginator
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="paginator.pageSize"
    [length]="paginator.length"
    [pageIndex]="paginator.pageIndex"
    showFirstLastButtons
    (page)="handlePageEvent($event)"
  ></mat-paginator>
</ng-template>
